import { UserDetailsResponseDto, UserDetailsResponseDtoAppFeaturesItem } from '@/generated/nabisNYWebAPI.schemas';
import { AxiosResponse } from 'axios';
import { OrganizationFeatureMap } from '../types/user-types';

export const getFeaturesFromUserDetailsResponse = (res: AxiosResponse<UserDetailsResponseDto, unknown>) => {
  const featuresForOrganizations = res.data?.featuresForOrganizations ?? {};
  const featuresForOrganizationsMap = Object.keys(featuresForOrganizations).reduce<OrganizationFeatureMap>(
    (acc, key) => {
      acc.set(key, featuresForOrganizations[key] as UserDetailsResponseDtoAppFeaturesItem[]);
      return acc;
    },
    new Map(),
  );

  return {
    featuresForOrganizationsMap,
    appFeatures: res?.data?.appFeatures ?? [],
  };
};
